import { render } from "./NewValidationContainer.vue?vue&type=template&id=4a90b112"
import script from "./NewValidationContainer.vue?vue&type=script&lang=js"
export * from "./NewValidationContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__